var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000099;stroke-width:14.2105;stroke-miterlimit:10;}\n\t.st1{fill:#000099;}\n\t.st2{fill:none;stroke:#000099;stroke-width:14;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000099;stroke-width:12;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000099;stroke-width:11;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000099;stroke-width:10;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "100,56.53 99.97,100 132.11,100  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.07,99.99c0,37.05-30.03,67.08-67.06,67.08c-37.05,0-67.08-30.03-67.08-67.08 c0-37.03,30.03-67.07,67.08-67.07C137.05,32.93,167.07,62.96,167.07,99.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.8001480f97c1d8ece142ff2372c61bb2.svg";
export { ForwardRef as ReactComponent };